

export class CountryBE {
    constructor(){}
    Id: number;
    Name: string = '';
    IsEnabled: boolean;
    ISO2: string = '';
    DialCode:any;
}